import { ValidationConfig } from '../../../../services/Main/types.Field';
import { FieldProps } from '../../Field/types';

export const getRowValidationConfigs = (
  validationConfig?: ValidationConfig
) => {
  return validationConfig?.validations.find((v) => v.type === 'of')
    ?.params[0] as Pick<FieldProps, 'name' | 'validationConfig'>[] | undefined;
};
